import { render, staticRenderFns } from "./cargoCode.vue?vue&type=template&id=138095f2&"
import script from "./cargoCode.vue?vue&type=script&lang=js&"
export * from "./cargoCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('138095f2')) {
      api.createRecord('138095f2', component.options)
    } else {
      api.reload('138095f2', component.options)
    }
    module.hot.accept("./cargoCode.vue?vue&type=template&id=138095f2&", function () {
      api.rerender('138095f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/ae/basic/cargoCode.vue"
export default component.exports